import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";

const LoginForm = () => {
  useEffect(() => {
    document.body.classList.add("my-page-body");
    return () => {
      document.body.classList.remove("my-page-body");
    };
  }, []);

  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("password", password);

      const res = await fetch(
        "http://backend.goldensection.agency/public/api/admin/login",
        {
          method: "POST",
          body: formData,
        },
      );

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "خطأ في تسجيل الدخول");
        return;
      }

      // ✅ حفظ التوكن والاسم والدور
      localStorage.setItem("token", data.token);
      localStorage.setItem("name", data.admin.name);
      localStorage.setItem("role", data.admin.role);
      localStorage.setItem("image", data.admin.image);

      // ✅ التوجيه حسب الدور
      if (data.admin.role === "admin") {
        navigate("/admin");
      } else if (data.admin.role === "user") {
        navigate("/dashboard");
      } else if (data.admin.role === "gust") {
        navigate("/admin");
      } else {
        setError("دور غير معروف!");
      }
    } catch (err) {
      console.error(err);
      setError("مشكلة في الاتصال بالسيرفر");
    }
  };

  return (
    <form className="auth-form" onSubmit={handleLogin}>
      <img src={logo} alt="" style={{ width: "100px", height: "100px" }} />
      <h2>تسجيل الدخول</h2>
      <label for="lemail">
        <i class="fa-solid fa-user"></i>
        البريد الإلكتروني
      </label>
      <input
        type="email"
        placeholder="البريد الإلكتروني"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        id="lemail"
      />
      <label for="lpass">
        <i class="fa-solid fa-key"></i>
        كلمة المرور
      </label>

      <input
        type="password"
        placeholder="كلمة المرور"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        id="lpass"
      />

      <button type="submit">تسجيل الدخول</button>

      {error && <p style={{ color: "red" }}>{error}</p>}

      <p>
        ليس لديك حساب؟{" "}
        <span className="link">
          <a href="https://goldensection.agency/contact/">
            تواصل معنا لانشاء حساب
          </a>
        </span>
      </p>
    </form>
  );
};

export default LoginForm;
